import { memo } from 'react'
import VisualMediaTracks from './VisualMediaTracks'
import EmptyTrack from './EmptyTrack'
import { useSelector } from 'react-redux'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import PlusButton from '../../PlusButton'
import * as Styled from './styled'
import { TIMELINE_DROP_ZONE_ID } from 'consts'
import DropIndicator from 'components/DropIndicator'

const Tracks = (props: { preventOnClick: boolean }) => {
  const hasMediaItems = useSelector(projectDataSelectors.hasMediaItems)

  return (
    <Styled.TracksContainer id={TIMELINE_DROP_ZONE_ID}>
      {hasMediaItems ? <VisualMediaTracks {...props} /> : <EmptyTrack />}
      {hasMediaItems && <PlusButton />}
      <DropIndicator />
    </Styled.TracksContainer>
  )
}

export default memo(Tracks)

type TItemType = 'text' | 'video' | 'image' | 'audio'

type TMetadata = ITextMetadata
interface IItem {
  type: TItemType
  metadata: TMetadata
}

interface ITextMetadata {
  property1: string
}

const item: IItem = {
  type: 'text',
  metadata: {
    property1: 'value'
  }
}

item.metadata.property1
